export default __webpack_public_path__ + "static/media/img2.a7238b34.png";